// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"References_checkbox-container__2KNfw","switch":"References_switch__2zUTf","options":"References_options__3OAXN"};